var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Components as ComponentsUI } from '@pacem/pacem-ui';
import { P, PCSS, ViewChild, CustomElement, Watch, Utils, PropertyConverters, Defaults, avoidHandler, Components, UI } from '@pacem/pacem-core';
import { PacemBaseElement } from './types-components';
//namespace Pacem.Components.Scaffolding {
// TODO: exploit 202x features like https://developer.mozilla.org/en-US/docs/Web/CSS/offset-path or https://developer.chrome.com/blog/anchor-positioning-api
let PacemSliderElement = class PacemSliderElement extends PacemBaseElement {
    constructor() {
        super(...arguments);
        this.inputFields = [];
        this._dragHandler = (evt) => {
            evt.preventDefault();
            this._computeAndAssignValue(evt.detail.currentPosition.x, this.changePolicy !== 'end');
        };
        this._endHandler = (evt) => {
            evt.preventDefault();
            this._computeAndAssignValue(evt.detail.currentPosition.x, this.changePolicy === 'end');
        };
        this._startHandler = (evt) => {
            this._thumb.focus();
        };
        this._downHandler = (evt) => {
            const x = evt instanceof MouseEvent ? evt.clientX : evt.touches && evt.touches.length && evt.touches[0].clientX, trackSize = this._trackSize;
            if (!Utils.isNullOrEmpty(trackSize)) {
                this._computeAndAssignValue(x, true);
            }
        };
        this._keydownHandler = (evt) => {
            switch (evt.keyCode) {
                case 39: // right
                case 37: // left
                    avoidHandler(evt);
                    let forward = evt.keyCode === 39; // TODO: include rtl!
                    let step = (typeof this.step !== 'number' ? 1.0 : this.step) * (forward ? 1 : -1);
                    let cease = false;
                    let ceaseFn = (evt) => {
                        cease = true;
                        window.removeEventListener('keyup', ceaseFn, false);
                        Utils.removeClass(this, 'slider-keydown');
                    };
                    window.addEventListener('keyup', ceaseFn, false);
                    Utils.addClass(this, 'slider-keydown');
                    Utils.accelerateCallback(token => {
                        if (!(token.cancel = cease)) {
                            this._setValue(this.value + step);
                        }
                    });
                    break;
            }
        };
    }
    onChange(evt) {
        return new Promise((resolve, reject) => {
            if (evt.type === 'slide') {
                resolve(this.value = evt.detail);
            }
            resolve(this.value);
        });
    }
    _draw(val = this.value) {
        const trackSize = this._trackSize;
        if (Utils.isNull(trackSize)) {
            return;
        }
        const v = Utils.isNullOrEmpty(val) ? this.min : parseFloat(val);
        const percentage = Math.min(1, Math.max(0, (v - this.min) / (this.max - this.min)));
        this._progress.style.transform = `scale(${(percentage)}, 1)`;
        this._thumb.style.transform = `translateX(${Math.round(percentage * trackSize.width)}px)`;
    }
    _format(v) {
        const intl = this.format;
        if (!Utils.isNullOrEmpty(intl)) {
            return new Intl.NumberFormat(Utils.lang(this), intl).format(v);
        }
        // fallback
        let sv = '-';
        if (!Utils.isNull(v)) {
            sv = v.toLocaleString();
        }
        let evt = new CustomEvent("formatvalue", { detail: { value: v } });
        this.dispatchEvent(evt);
        return Utils.isNull(evt.detail.output) ? sv : evt.detail.output;
    }
    acceptValue(val) {
        this._draw(val);
    }
    getViewValue(value) {
        return this._format(value);
    }
    convertValueAttributeToProperty(attr) {
        return parseFloat(attr);
    }
    toggleReadonlyView(readonly) {
        this._thumb.hidden = readonly;
        const css = 'cursor-pointer';
        if (readonly) {
            Utils.removeClass(this._max, css);
            Utils.removeClass(this._min, css);
        }
        else {
            Utils.addClass(this._max, css);
            Utils.addClass(this._min, css);
        }
    }
    _setTrackSize(evt) {
        const size = evt.detail;
        this._trackSize = { x: size.left, y: size.top, width: size.width, height: size.height };
        this._draw(this.value);
    }
    _computeAndAssignValue(x, triggerChange) {
        if (this.readonly || this.disabled) {
            return;
        }
        // constraint to track size to compute the slider value
        const constraint = this._trackSize, step = this.step;
        let perc = (x - constraint.x) / constraint.width;
        let v = (this.max - this.min) * perc + this.min;
        if (typeof step === 'number') {
            v = Math.round(v / step) * step;
        }
        if (triggerChange) {
            this._setValue(v);
        }
        else {
            this._draw(v);
        }
    }
    _setValue(v) {
        if (isNaN(v) || Utils.isNull(v)) {
            // keep in sync with pacem-input-number logic (TODO: centralize code, this is a fix)
            // cast NaN to undefined
            v = undefined;
        }
        else {
            if (!isNaN(this.min) && v < this.min) {
                v = this.min;
            }
            if (!isNaN(this.max) && v > this.max) {
                v = this.max;
            }
        }
        this.changeHandler(new CustomEvent('slide', { detail: v }));
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('mousedown', this._downHandler, false);
        this.addEventListener('touchstart', this._downHandler, { passive: false, capture: false });
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._dragger.addEventListener(UI.DragDropEventType.Init, this._startHandler, false);
        this._dragger.addEventListener(UI.DragDropEventType.Drag, this._dragHandler, false);
        this._dragger.addEventListener(UI.DragDropEventType.End, this._endHandler, false);
        this._thumb.addEventListener('keydown', this._keydownHandler, false);
        this._min.text = this._format(this.min);
        this._max.text = this._format(this.max);
        // balloon
        const balloon = this._shellProxy.dom[0];
        if (!Utils.isNull(balloon)) {
            balloon.target = this._thumb;
            balloon.options = {
                trigger: ComponentsUI.UI.BalloonTrigger.Focus,
                trackPosition: true,
                position: ComponentsUI.UI.BalloonPosition.Top,
                align: ComponentsUI.UI.BalloonAlignment.Center,
                behavior: ComponentsUI.UI.BalloonBehavior.Tooltip,
                hoverDelay: 0, hoverTimeout: 0
            };
            this._syncThumbLabel();
        }
        //
        this._thumb.tabIndex = 0;
    }
    _syncThumbLabel(thumbLabel = this.thumbLabel) {
        const balloon = this._shellProxy.dom[0];
        (thumbLabel ? Utils.addClass : Utils.removeClass).apply(this, [this, 'slider-thumblabel']);
        balloon.disabled = !thumbLabel;
    }
    disconnectedCallback() {
        this.removeEventListener('mousedown', this._downHandler, false);
        this.removeEventListener('touchstart', this._downHandler, { capture: false });
        if (!Utils.isNull(this._dragger)) {
            this._dragger.removeEventListener(UI.DragDropEventType.End, this._endHandler, false);
            this._dragger.removeEventListener(UI.DragDropEventType.Drag, this._dragHandler, false);
            this._dragger.removeEventListener(UI.DragDropEventType.Init, this._startHandler, false);
        }
        if (!Utils.isNull(this._thumb)) {
            this._thumb.removeEventListener('keydown', this._keydownHandler, false);
        }
        super.disconnectedCallback();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (first) {
            return;
        }
        switch (name) {
            case 'thumbLabel':
                this._syncThumbLabel(val);
                break;
            case 'min':
            case 'max':
                if (!Utils.isNull(this._max) && !Utils.isNull(this._min)) {
                    this._min.text = this._format(this.min);
                    this._max.text = this._format(this.max);
                }
                this._setValue(this.value);
                this._draw();
                break;
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemSliderElement.prototype, "min", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemSliderElement.prototype, "max", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemSliderElement.prototype, "thumbLabel", void 0);
__decorate([
    Watch({
        emit: false, converter: {
            convert: (attr) => {
                let v = parseFloat(attr);
                if (isNaN(v)) {
                    return 'any';
                }
                return v;
            }, convertBack: (v) => (v || '').toString()
        }
    })
], PacemSliderElement.prototype, "step", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemSliderElement.prototype, "changePolicy", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemSliderElement.prototype, "format", void 0);
__decorate([
    ViewChild(`.slider-track`)
], PacemSliderElement.prototype, "_track", void 0);
__decorate([
    ViewChild(`.slider-progress`)
], PacemSliderElement.prototype, "_progress", void 0);
__decorate([
    ViewChild(`.slider-thumb`)
], PacemSliderElement.prototype, "_thumb", void 0);
__decorate([
    ViewChild(`${P}-text[min]`)
], PacemSliderElement.prototype, "_min", void 0);
__decorate([
    ViewChild(`${P}-text[max]`)
], PacemSliderElement.prototype, "_max", void 0);
__decorate([
    ViewChild(`${P}-drag-drop`)
], PacemSliderElement.prototype, "_dragger", void 0);
__decorate([
    ViewChild(`${P}-shell-proxy`)
], PacemSliderElement.prototype, "_shellProxy", void 0);
PacemSliderElement = __decorate([
    CustomElement({
        tagName: P + '-slider',
        template: `<div class="${PCSS}-viewfinder ${PCSS}-slider"><${P}-text text="{{ :host._format(:host.min) }}" min></${P}-text>
    <div class="slider-track"><div class="slider-progress"></div></div>
    <${P}-panel class="${PCSS}-clickable slider-thumb" behaviors="{{ [::_dragger] }}">
        <div class="thumb-label"></div>
    </${P}-panel>
    <${P}-text text="{{ :host._format(:host.max) }}" max></${P}-text>
    <div class="slider-footer"><${P}-text text="{{ :host.viewValue }}"></${P}-text></div>
    </div>
<${P}-drag-drop lock-timeout="0"></${P}-drag-drop><${P}-resize watch-position="true" on-${Components.ResizeEventName}=":host._setTrackSize($event)" target="{{ ::_track }}"></${P}-resize>
<${P}-shell-proxy><${P}-balloon class="text-center"><${P}-text text="{{ :host.viewValue }}"></${P}-text></${P}-balloon></${P}-shell-proxy>
`,
        shadow: Defaults.USE_SHADOW_ROOT
    })
], PacemSliderElement);
export { PacemSliderElement };
